import React from 'react';
import clsx from 'clsx';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import ImageSelector from '@di-shared/features/common/ImageSelector';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {BrandType} from '@shared/cci/features/const/environment';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 350;

function CapitalEvent1BottomSheetPage(): JSX.Element {
  const {t} = useInferableTranslation();
  const brand = import.meta.env.VITE_BRAND as 'KIA' | 'HYUNDAI' | 'GENESIS';
  const prizeCarName = brand === BrandType.KIA ? 'The 2026 K8을' : brand === BrandType.HYUNDAI ? '팰리세이드를' : 'G80을';
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <div className={clsx('bottom_sheet', brand === BrandType.GENESIS ? 'bottom_sheet_intro_event' : 'bottom_sheet_intro_guide')}>
        <div className="bottom_sheet_header">
          <button
            type="button"
            className="btn btn_ic"
            aria-label={t('T10017')}
            onClick={() => window.bottomSheetClose(false)}
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        <div className="bottom_sheet_inner">
          <div className="bottom_sheet_contents">
            <strong className="intro_guide_title">
              <span className="title_text">마이데이터 럭키드로우 이벤트</span>
              {brand === BrandType.GENESIS ? (
                <span className="title_sub_text">
                  내 차 보험<span className="mid_dot"></span>대출 연결하고
                  <br />
                  G80 당첨의 주인공이 되어 보세요.
                </span>
              ) : (
                <span className="title_sub_text">
                  내 차 보험<span className="mid_dot"></span>대출 연동하고 <br />
                  {prizeCarName} 잡아라!
                </span>
              )}
            </strong>
            <div className="intro_event_imgbox">
              <ImageSelector
                className="intro_event_img"
                alt="intro_event_img"
                kiaLightSrc={() => import('@di-shared/assets/img/event/img_event_popup_light.png')}
                kiaDarkSrc={() => import('@di-shared/assets/img/event/img_event_popup.png')}
                hyundaiLightSrc={() => import('@di-shared/assets/img/event/hyundai/img_event_popup_light.png')}
                hyundaiDarkSrc={() => import('@di-shared/assets/img/event/hyundai/img_event_popup.png')}
                genesisLightSrc={() => import('@di-shared/assets/img/event/genesis/img_event_popup.png')}
                genesisDarkSrc={() => import('@di-shared/assets/img/event/genesis/img_event_popup.png')}
              />
            </div>
            <p className="event_desc">
              마이데이터 기반의 자산관리 서비스와 관련 제휴
              <br />
              이벤트는 제휴사 현대캐피탈을 통해 운영 및 제공됩니다.
            </p>
          </div>

          <div className="bottom_sheet_footer bottom_sheet_footer_vertical">
            <button
              type="button"
              className="btn btn_large btn_filled"
              onClick={() => window.bottomSheetClose(0)}
            >
              {brand === BrandType.GENESIS ? '이벤트 참여하기' : '바로가기'}
            </button>

            <button
              type="button"
              className="btn btn_large btn_ghost"
              onClick={() => window.bottomSheetClose(1)}
            >
              {brand === BrandType.GENESIS ? '하루 동안 보지 않기' : '오늘 하루 보지 않기'}
            </button>
          </div>
        </div>
      </div>
    </BottomSheetWebViewWrapper>
  );
}

export default CapitalEvent1BottomSheetPage;
